<template lang="pug">
#plan_select
  plan-interval-menu(:interval="interval", :interval_count="interval_count", :is_new_ui="is_new_ui")
  div.text-right.mb-2
    a(href="/users/plans/custom") 200万PV以上をご希望の方はこちら
  table.table.table-bordered
    thead
      tr
        th.blank(:colspan="2")
        th(v-for="plan in display_plans",:class="plan.name") {{plan.display_name}}
    tbody
      tr
        th(:colspan="2" :rowspan="2") 料金
        td(v-for="plan in display_plans")
          template(v-if="is_monthly")
            strong {{toCurrency(plan.amount/month_param)}}円
          template(v-else-if="plan.name=='free'")
            strong {{toCurrency(plan.amount/month_param)}}円
          template(v-else)
            s {{formatBeforePrice(plan.amount)}}円
            br/
            div ▼
            strong {{formatPrice(plan.amount)}}円
      tr(v-if="!no_button && !invoice_failed")
        td.text-center(v-for="(plan, index) in display_plans")
          template(v-if="isSamePlan(plan)")
            template(v-if="isSameId(plan)")
              button.btn.btn-default 現在のプラン
            template(v-else-if="plan.name == 'free'")
              button.btn.btn-default 現在のプラン
            template(v-else)
              button.btn.btn-default(@click="upgrade( plan )") 支払期間変更
          template(v-else-if="isLowerPlan(plan)")
            template(v-if="index!=0")
              template(v-if="plan.name == 'premium'")
                button.btn.btn-secondary(disabled style="opacity: 0.5") ダウングレード
                div.text-danger.small.mt-1 ※新規申込終了
              template(v-else)
                button.btn.btn-secondary(@click="downgrade( plan )") ダウングレード
            template(v-else)
              button.btn.btn-secondary(@click="cancelPlan") ダウングレード
          template(v-else-if="isUpperPlan(plan)")
            template(v-if="plan.name == 'premium'")
              button.btn.btn-primary(disabled style="opacity: 0.5") アップグレード
              div.text-danger.small.mt-1 ※新規申込終了
            template(v-else)
              button.btn.btn-primary(@click="upgrade( plan )") アップグレード
    tbody
      tr
        th.heatmap(:rowspan="5", style='width: 10%;') ヒートマップ
      tr
        th PV数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1,000
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.heatmap_imp_limit.toLocaleString()}}/月
      tr
        th 登録ドメイン数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1ドメイン
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th 登録URL数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th 計測データ保存期間
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 30日
          template(v-else)
            i.fa.fa-check-circle {{dataPeriod(plan)}}
      tr
        th.empty(:colspan="plan_count")
      tr
        th.popup(:rowspan="7", style='width: 10%;')
          div ポップアップ
          div オーバーレイ
      tr
        th PV数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1,000
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.overlay_imp_limit.toLocaleString()}}/月
      tr
        th 登録クリエイティブ数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1個
          template(v-else)
            i.fa.fa-check-circle 無制限
      tr
        th パラメータ引継ぎ
        td(v-for="(plan, index) in display_plans")
          template(v-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th カウントダウンタイマー
        td(v-for="(plan, index) in display_plans")
          template(v-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th 表示日時予約
        td(v-for="(plan, index) in display_plans")
          template(v-if="isMoreMaster(plan)")
            i.fa.fa-check-circle あり
          template(v-else="") なし
      tr
        th
          <div>「Powered By SiteLead」表記</div>
        td(v-for="(plan, index) in display_plans")
          template(v-if="isMoreMaster(plan)")
            i.fa.fa-check-circle なし
          template(v-else="") あり
      tr
        th.empty(:colspan="plan_count")
      tr
        th.widget(:rowspan="6", style='width: 10%;') ウィジェット
      tr
        th PV数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'")
            div 上限無し
            div (広告表示あり)
          template(v-else)
            i.fa.fa-check-circle {{plan.widget_imp_limit.toLocaleString()}}/月
      tr
        th 登録ドメイン数
        td(v-for="(plan, index) in display_plans")
          template(v-if="isOneDomain(plan)") 1ドメイン
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th 登録ウィジェット数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1個まで
          template(v-else)
            i.fa.fa-check-circle 無制限
      tr
        th ウィジェットへの広告表示
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") あり
          template(v-else="")
            i.fa.fa-check-circle なし
      tr
        th
          <div>クレジット表記</div>
          <div>「Powered By SiteLead」表記</div>
        td(v-for="(plan, index) in display_plans")
          template(v-if="isMoreMaster(plan)")
            i.fa.fa-check-circle なし
          template(v-else="") あり

      tr(v-if="is_new_ui")
        th.conversion(:rowspan="5", style='width: 10%;')
          div コンバージョン計測
      tr(v-if="is_new_ui")
        th ページビュー計測
        td(v-for="plan in display_plans")
          template あり
      tr(v-if="is_new_ui")
        th ボタンクリック計測【開発中】
        td(v-for="plan in display_plans")
          template あり
      tr(v-if="!no_button && !invoice_failed")
        th.blank(:colspan="2")
        td.text-center(v-for="(plan, index) in display_plans")
          template(v-if="isSamePlan(plan)")
            template(v-if="isSameId(plan)")
              button.btn.btn-default 現在のプラン
            template(v-else-if="plan.name == 'free'")
              button.btn.btn-default 現在のプラン
            template(v-else)
              button.btn.btn-default(@click="upgrade( plan )") 支払期間変更
          template(v-else-if="isLowerPlan(plan)")
            template(v-if="index!=0")
              template(v-if="plan.name == 'premium'")
                button.btn.btn-secondary(disabled style="opacity: 0.5") ダウングレード
                div.text-danger.small.mt-1 ※新規申込終了
              template(v-else)
                button.btn.btn-secondary(@click="downgrade( plan )") ダウングレード
            template(v-else)
              button.btn.btn-secondary(@click="cancelPlan") ダウングレード
          template(v-else-if="isUpperPlan(plan)")
            template(v-if="plan.name == 'premium'")
              button.btn.btn-primary(disabled style="opacity: 0.5") アップグレード
              div.text-danger.small.mt-1 ※新規申込終了
            template(v-else)
              button.btn.btn-primary(@click="upgrade( plan )") アップグレード
</template>

<script>



import Vue from 'vue';

import StrMixin from '../mixins/str';

import PlanIntervalMenu from '../components/plan_interval_menu.vue';

export default {
  props: {
    plans: { type: String, default: [] },
    plan_interval_name: {type: String, default: "month"},
    current_plan_name: { type: String, default: "free" },
    current_plan_id: { type: String, default: null },
    has_stripe_customer_id: { type: Boolean, default: null },
    invoice_failed: { type: Boolean, default: false },
    is_upgrade: { type: Number, default: 0, require: false },
    hide_above_idx: { type: Number, default: 0, require: false },
    no_button: { type: Boolean, default: false },
    interval: { type: String, default: "month" },
    interval_count: { type: String, default: "1" },
    is_new_ui: { type: Boolean, default: false },
  },
  data(){
    return {
      plans_arr: [],
    }
  },
  components: {
    PlanIntervalMenu
  },
  methods: {
    upgrade(plan){
      this.$store.commit("user/setPlanToChange", plan)
      if(this.has_stripe_customer_id == false){
        this.$bvModal.show('set-user-credit-card')
      } else {
        // 保持してるクーポンは一度リセット
        if (this.$store.state.user.coupon_code) this.$store.commit("user/setCouponCode", "")
        this.$bvModal.show('change-user-plan')
      }
    },
    downgrade(plan){
      this.$store.commit("user/setPlanToChange", plan)
      // 保持してるクーポンは一度リセット
      if (this.$store.state.user.coupon_code) this.$store.commit("user/setCouponCode", "")
      this.$bvModal.show('change-user-plan')
      //this.resetCurrentPlanIdx(plan.name)
    },
    cancelPlan(){
      this.$bvModal.show('cancel-user-plan')
      //this.resetCurrentPlanIdx("free")
    },
    isUpperPlan(plan){
      return this.$store.getters["user/is_upper_plan"](plan)
    },
    isLowerPlan(plan){
      return this.$store.getters["user/is_lower_plan"](plan)
    },
    isSamePlan(plan){
      return this.$store.getters["user/is_same_plan"](plan)
    },
    isSameId(plan){
      return this.$store.getters["user/is_same_id"](plan)
    },
    planByIdx(idx){
      let plans = this.$store.getters["user/display_plans"]
      return plans[idx]
    },
    resetCurrentPlanIdx(new_plan_name){
      var _this = this
      this.plans_arr.forEach((plan, idx)=>{
        if(new_plan_name == plan.name){
          _this.current_plan_idx = idx
        }
      })
    },
    isOneDomain(plan){
      if(
        plan.name=="free" ||
        plan.name=="basic"
      ){
        return true
      } else {
        return false
      }
    },
    hasCountdown(plan){
      if(
        plan.name=="master" ||
        plan.name=="enterprise" ||
        plan.name=="1m_pv" ||
        plan.name=="2m_pv"
      ){
        return true
      } else {
        return false
      }
    },
    isMoreMaster(plan){
      if(
        plan.name=="master" ||
        plan.name=="enterprise" ||
        plan.name=="1m_pv" ||
        plan.name=="2m_pv"
      ){
        return true
      } else {
        return false
      }
    },
    isMaster(plan){
      if(
        plan.name=="master"
      ){
        return true
      } else {
        return false
      }
    },
    isFree(plan){
      if(
        plan.name=="free"
      ){
        return true
      } else {
        return false
      }
    },
    isBasic(plan){
      if(
        plan.name=="basic"
      ){
        return true
      } else {
        return false
      }
    },
    isEnterprise(plan){
      if(
        plan.name=="enterprise"
      ){
        return true
      } else {
        return false
      }
    },
    formatPrice(number){
      return (number/(this.month_param)).toLocaleString('ja-JP')
    },
    formatBeforePrice(number){
      return parseInt((number/(this.month_param))*(1/(1-this.discount))).toLocaleString('ja-JP')
    },
    formatAnnualBeforePrice(number){
      return parseInt(((number/(this.month_param))*(1/(1-this.discount))-number/(this.month_param))*12).toLocaleString('ja-JP')
    },

    dataPeriod(plan){
      if(
        plan.name=="custom" ||
        plan.name=="enterprise" ||
        plan.name=="1m_pv" ||
        plan.name=="2m_pv"
      ){
        return "365日"
      } else {
        return "180日"
      }
    },
  },
  mixins:[StrMixin],
  watch: {
    '$store.state.user.plan_name': function (val) {
      this.$store.dispatch("user/updateCurrentPlanIdx")
    },
  },
  computed: {
    plan_name(){
      return this.$store.state.user.plan_name
    },
    plan_count(){
      if(this.display_plans!=undefined){
        return this.display_plans.length+1
      } else {
        1
      }
    },
    display_plans(){
      let plans = this.$store.getters["user/display_plans"]
      let plan_ranks = []
      if(this.is_upgrade){
        plan_ranks = {
          free : 0,
          basic :1,
          premium : 2,
          master : 3,
          enterprise : 4
        }
        let current_plan_rank = plan_ranks[this.current_plan_name]
        if(plans!=undefined){
          return plans.filter(plan => plan_ranks[plan.name] >= current_plan_rank)
        }
      } else {
        return plans
      }
    },
    month_param(){
      if(this.$store.state.user.is_anual){
        return 12
      } else {
        return parseInt(this.$store.state.user.interval_count)
      }
    },
    discount(){
      if(this.$store.state.user.is_anual){
        return 0.4
      } else {
        if(this.$store.state.user.interval_count == 6){
          return 0.3
        } else if(this.$store.state.user.interval_count == 3) {
          return 0.2
        } else {
          return 0
        }
      }
    },
    plan_span_name(){
      if(this.interval == "year"){
        return "1年間プラン"
      } else {
        return this.interval_count+"ヶ月払いプラン"
      }
    },
    is_monthly(){
      if(!this.$store.state.user.is_anual && this.$store.state.user.interval_count == 1){
        return true
      } else {
        return false
      }
    }
  },
  async mounted(){
    await Vue.nextTick()
    //console.log("this.interval_count",this.interval_count)
    this.$store.commit("user/setPlanId", this.current_plan_id)
    this.$store.commit("user/setHideAboveIdx", this.hide_above_idx)
    this.$store.commit("user/setPlansArr", JSON.parse(this.plans))
    this.$store.commit("user/setPlanIntervalName", this.plan_interval_name)
    if(this.is_upgrade==0){
      this.$store.commit("user/unshiftPlansArr", {name: "free", display_name: "Free", amount: 0, widget_imp_limit: 0, pop_up_imp_limit: 0, overlay_imp_limit: 0})
    }
    this.$store.commit("user/setPlanName", this.current_plan_name)
    //console.log("no_button", this.no_button)
  },
}
</script>
<style lang="scss" scoped>
.callout{
  a{
    color:white;
    text-decoration:none;
  }
}
table{
  .heatmap{
    background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #0080ff, #00b2b5);
    color: white;
    vertical-align: middle;
  }
  .popup{
    background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #dc3545, #ff7838);
    color: white;
    vertical-align: middle;
  }
  .widget{
    background: url(/images/hero_bg_pattern.png), linear-gradient(rgb(255, 170, 0), #f1d04e);
    color: white;
    vertical-align: middle;
  }
  .conversion{
    background: url(/images/hero_bg_pattern.png), linear-gradient(rgb(255, 170, 0), #f1d04e);
    color: white;
    vertical-align: middle;
  }
  th.empty{
    border: none;
    background: #ffff;
    padding:0.5rem 0.75rem;
  }
  strong{
    font-size: 1.5em
  }
}
</style>
